import { defineMessages } from "react-intl";

import { Status } from "lib/build/forms/ktx/committeeOpinion";

export const shortStatusMessages = defineMessages<Status>({
	[Status.NEW]: {
		id: "ktx.patient_status.short.new",
		defaultMessage: "ÚJ"
	},
	[Status.COMMITTEE_OPINION]: {
		id: "ktx.patient_status.short.committee_opinion",
		defaultMessage: "BV"
	},
	[Status.READY_FOR_COMMITTEE]: {
		id: "ktx.patient_status.short.ready_for_committee",
		defaultMessage: "BR"
	},
	[Status.WAITING_FOR_MEDICAL_EXAMINATION]: {
		id: "ktx.patient_status.short.waiting_for_medical_examination",
		defaultMessage: "KVV"
	},
	[Status.TRANSPLANTABLE]: {
		id: "ktx.patient_status.short.transplantable",
		defaultMessage: "T"
	},
	[Status.NON_TRANSPLANTABLE]: {
		id: "ktx.patient_status.short.non_transplantable",
		defaultMessage: "NT"
	},
	[Status.SUITABLE]: {
		id: "ktx.patient_status.short.suitable",
		defaultMessage: "ALS"
	},
	[Status.UNSUITABLE]: {
		id: "ktx.patient_status.short.unsuitable",
		defaultMessage: "ALK"
	},
	[Status.KTX_DONE]: {
		id: "ktx.patient_status.short.ktx_done",
		defaultMessage: "VTX"
	},
	[Status.EXIT]: {
		id: "ktx.patient_status.short.exit",
		defaultMessage: "EX"
	}
});

export const longStatusMessages = defineMessages<Status>({
	[Status.NEW]: {
		id: "ktx.patient_status.long.new",
		defaultMessage: "Új"
	},
	[Status.COMMITTEE_OPINION]: {
		id: "ktx.patient_status.long.committee_opinion",
		defaultMessage: "Bizottsági véleményezésre küldve"
	},
	[Status.READY_FOR_COMMITTEE]: {
		id: "ktx.patient_status.long.ready_for_committee",
		defaultMessage: "Bizottsági Referálásra Kész"
	},
	[Status.WAITING_FOR_MEDICAL_EXAMINATION]: {
		id: "ktx.patient_status.long.waiting_for_medical_examination",
		defaultMessage: "Kiegészítő Vizsgálatra Vár"
	},
	[Status.TRANSPLANTABLE]: {
		id: "ktx.patient_status.long.transplantable",
		defaultMessage: "Transzplantálható"
	},
	[Status.NON_TRANSPLANTABLE]: {
		id: "ktx.patient_status.long.non_transplantable",
		defaultMessage: "Nem Transzplantálható"
	},
	[Status.SUITABLE]: {
		id: "ktx.patient_status.long.suitable",
		defaultMessage: "Alkalmas"
	},
	[Status.UNSUITABLE]: {
		id: "ktx.patient_status.long.unsuitable",
		defaultMessage: "Alkalmatlan"
	},
	[Status.KTX_DONE]: {
		id: "ktx.patient_status.long.ktx_done",
		defaultMessage: "VTX megtörtént"
	},
	[Status.EXIT]: {
		id: "ktx.patient_status.long.exit",
		defaultMessage: "Exit"
	}
});

export const waitingListMessages = defineMessages({
	waitingListMonths: {
		id: "ktx.patient_status.waiting_list_months.title",
		defaultMessage: "{n}. hónapja ET várólistán"
	},
	waitingListDays: {
		id: "ktx.patient_status.waiting_list_days.title",
		defaultMessage: "{n} napja ET várólistán"
	}
});
